export default __webpack_public_path__ + "static/char-s-50-zh-Hans-0d4f3e2bb9977a82875b2710436a2e03.webp";